import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import RecipeMenuGroup from './RecipeMenuGroup';

const AlakartRecipeGrid = ({
    recipes,
    draft,
    activeDay,
    activeCategory,
    handleRecipeClick,
    handleToggleRecipe,
    userProfile,
    portion,
    recipesLoading
}) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 pb-12">
            <AnimatePresence mode="popLayout">
                {recipes.map((recipe, index) => {
                    const isSelected = draft[activeDay]?.[activeCategory] === recipe.id;
                    const hasPairings = recipe.suggestedPairings?.length > 0;

                    return (
                        <motion.div
                            key={recipe.id || index}
                            layout
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.9 }}
                            transition={{ delay: index * 0.05 }}
                            className={`${hasPairings ? 'md:col-span-2' : ''}`}
                        >
                            <RecipeMenuGroup
                                recipe={recipe}
                                isDarkMode={false} // Alakart has its own theme management usually, but RecipeMenuGroup needs it
                                onCardClick={handleRecipeClick}
                                onToggleSelect={(r) => {
                                    if (Array.isArray(r)) {
                                        const assignments = r.map(p => ({ slot: p.category, recipeId: p.id }));
                                        handleToggleRecipe(null, null, assignments);
                                    } else {
                                        handleToggleRecipe(r.id);
                                    }
                                }}
                                selectedRecipeNames={Object.values(draft[activeDay] || {})}
                                userPortion={portion}
                                hideInventoryStatus={true}
                                isAlakart={true}
                                isModern={true}
                            />
                        </motion.div>
                    );
                })}
            </AnimatePresence>

            {/* Empty State */}
            {!recipesLoading && recipes.length === 0 && (
                <div className="col-span-full flex flex-col items-center justify-center py-20 text-center">
                    <span className="material-symbols-outlined text-8xl text-slate-100 dark:text-slate-700 mb-4 animate-bounce">search_off</span>
                    <p className="text-slate-400 font-bold text-xl">Aradığın lezzet buralarda yok gibi şef...</p>
                    {draft[activeDay]?.[activeCategory] && (
                        <button
                            onClick={() => handleToggleRecipe(draft[activeDay][activeCategory])}
                            className="mt-4 text-primary font-black hover:underline"
                        >
                            Filtreyi Temizle (Seçimi Kaldır)
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default AlakartRecipeGrid;
